var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 288,
    viewBox: "0 0 257 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5896_6625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207 198.19C207 198.173 197.663 198.989 197.663 198.989V218.15H178.029C177.608 221.926 177.308 224.743 176.948 228H78.3951C77.9748 225.463 77.4944 222.685 76.934 219.269C74.3721 218.869 71.55 218.43 68.1275 217.89C67.7872 215.193 67.427 212.356 67.0067 208.999C64.0044 208.719 61.1623 208.46 58 208.16L50 169.25L58 149.399C60.8021 148.979 63.5841 148.58 66.9666 148.08C67.3269 145.323 67.6872 142.506 68.1275 139.009L76 129.356H156.833V119.269H108.357C107.857 122.086 107.296 125.123 106.716 128.38L58 128.1V110.407L50 88.891L67.487 79.4888H132.275L189.063 40.5923L194 59.9469H199L207 99.4289V198.19ZM107.937 187.92H156.993V169.179H107.937V187.92Z",
    fill: "url(#paint0_linear_5896_6625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 158.701C196.138 158.961 193.106 159.201 189.663 159.5V178.661H170.029C169.608 182.437 169.308 185.254 168.948 188.511L71 188.605L69 179.629L60 178.631L59 169.655L50 168.671V109.91L59 108.817L60 99.8408H138L140 89.8674L149 88.87V79.8939H100L99 88.891H50V60.2797C52.662 59.7602 55.8243 59.1808 59.487 58.4815V40L189.063 40.5923V58.3616C192.485 58.921 195.557 59.3806 199 59.94V158.701ZM99.9369 148.431H148.993V129.69H99.9369V148.431Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 60,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 52,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 52,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 64,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 112,
    width: 4,
    height: 4,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 68,
    width: 4,
    height: 8,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 76,
    width: 4,
    height: 28,
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5896_6625",
    x: 0,
    y: 0,
    width: 257,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.848333 0 0 0 0 0.458333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5896_6625"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5896_6625",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5896_6625",
    x1: 128.5,
    y1: 40,
    x2: 128.5,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA4CD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAHover);
export default __webpack_public_path__ + "static/media/A_hover.4746a80534a94752e668855821cc1ee4.svg";
export { ForwardRef as ReactComponent };